module.exports = __webpack_public_path__ + "img/nmvPostal.f9b3c5e2.png";